import type { FloraInstance, Vec3 } from '@/flora/FloraInstance';
import { duplicateInstances } from './DuplicateTool';

/**
 * Holds a detached copy of instances for copy/paste (spec §4.4). Stored entries are independent
 * snapshots; each paste yields fresh independent clones so pasting never re-links to the originals.
 */
export class ClipboardManager {
  private contents: FloraInstance[] = [];

  get isEmpty(): boolean {
    return this.contents.length === 0;
  }

  get size(): number {
    return this.contents.length;
  }

  /** Copy instances into the clipboard as independent snapshots. */
  copy(instances: Iterable<FloraInstance>): void {
    // Store as independent clones so later edits to the originals don't mutate clipboard contents.
    this.contents = duplicateInstances(instances, { x: 0, y: 0, z: 0 });
  }

  /** Produce fresh independent clones of the clipboard contents, offset for visibility. */
  paste(offset: Vec3 = { x: 1, y: 0, z: 1 }): FloraInstance[] {
    return duplicateInstances(this.contents, offset);
  }

  clear(): void {
    this.contents = [];
  }
}
